module.exports = __webpack_public_path__ + "static/media/icon_pause.ca6e0921.svg";